'use client';

import { createContext, useContext } from 'react';

export type ImpersonatedBroker = {
  id: string;
  name: string;
  officeName: string;
  avatarUrl?: string;
};

export type MasterAdminContextType = {
  /** true when the master admin is currently acting as a broker */
  isImpersonating: boolean;
  impersonatedBroker: ImpersonatedBroker | null;
  /** Enters the office-admin session for this directory row. */
  loginAsBroker: (broker: ImpersonatedBroker) => Promise<void>;
  /** Ends the office session, then signs the master in again. */
  returnToMasterAdmin: () => Promise<void>;
};

export const MasterAdminContext = createContext<MasterAdminContextType>(null!);

export const useMasterAdmin = () => useContext(MasterAdminContext);
